import { workspaceModel } from 'APP/model/model';
import Entities from 'STORE';

export async function loadWorkspace(): Promise<void> {
  try {
    const data = await workspaceModel.getWorkspace();

    Entities.workspace.updatePersonalizedWorkspace(data);
  } catch {
    //
  }
}
